module.exports = __webpack_public_path__ + "img/st-john-berchmann.3d832548.jpg";